import React from 'react';
import * as R from 'ramda';

import { PosPlugin } from 'plugins/plugin';

import { CustomerSection } from './features/customerToRowAssignment/CustomerSection';
import { duplicateReceiptIfFirstPrint } from './features/receiptDuplication/duplicateReceiptIfFirstPrint';
import { addProductGroupFooters } from './features/receiptFooters/addProductGroupFooters';
import { TgfPluginMeta } from './meta';
import { Config, Configuration } from './configuration/Configuration';

export const TgfPlugin: PosPlugin<Config> = {
  ...TgfPluginMeta,
  getStatus: state => ({ type: 'valid', message: 'OK' }),
  combineConfiguration: c => c ?? {},
  ComponentConfigurationByLevel: {
    Company: Configuration,
  },

  /** Enable assigning customers to each invoice row */
  UIProductFormBody: ({ children, order }) => {
    return (
      <>
        <div className="customer-assignment">
          <CustomerSection order={order} />
        </div>
        {children}
      </>
    );
  },
  onGenerateReceipt: {
    on: addProductGroupFooters,
  },
  // Print extra copies of the receipt based on preconfigured rules
  onPrintReceipt: {
    on: duplicateReceiptIfFirstPrint,
  },
};
